import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { TELEFONO, TELEFONO_HREF, EMAIL, INDIRIZZO, CITTA } from "@/data/citta";

const LINK_SERVIZI = [
  { label: "Elettricista H24", path: "/servizi/elettricista" },
  { label: "Fabbro H24", path: "/servizi/fabbro" },
  { label: "Idraulico H24", path: "/servizi/idraulico" },
  { label: "Perdita d'acqua", path: "/servizi/idraulico/perdita-acqua" },
  { label: "Spurgo H24", path: "/servizi/spurgo" },
  { label: "Caldaie e clima H24", path: "/servizi/caldaie" },
];

const LINK_PAGINE = [
  { label: "Pronto intervento H24", path: "/pronto-intervento-h24" },
  { label: "Chi siamo", path: "/chi-siamo" },
  { label: "Come funziona", path: "/come-funziona" },
  { label: "FAQ", path: "/faq" },
  { label: "Contatti", path: "/contatti" },
];

export function Footer() {
  return (
    <footer className="border-t border-slate-800 bg-abyss" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid grid-cols-1 gap-12 text-center sm:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col items-center">
            <Logo />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Pronto intervento multiservizio attivo 24 ore su 24 in tutta la Lombardia.
              Tecnici certificati e preventivi trasparenti, sempre.
            </p>
          </div>
          <div className="flex flex-col items-center">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400">
              Servizi H24
            </h4>
            <ul className="mt-5 space-y-2.5 text-sm text-slate-300">
              {LINK_SERVIZI.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    data-testid={`footer-servizio-${l.path.split("/").pop()}`}
                    className="transition-colors hover:text-amber-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col items-center">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400">
              Dove interveniamo
            </h4>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2.5 text-sm text-slate-300">
              {CITTA.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/citta/${c.slug}`}
                    data-testid={`footer-citta-${c.slug}`}
                    className="transition-colors hover:text-amber-400"
                  >
                    {c.nome}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col items-center">
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400">
              Contatti
            </h4>
            <ul className="mt-5 space-y-3.5 text-sm text-slate-300">
              <li>
                <a
                  href={TELEFONO_HREF}
                  data-testid="footer-telefono"
                  className="flex items-center justify-center gap-2.5 transition-colors hover:text-amber-400"
                >
                  <Phone size={15} className="text-amber-400" /> {TELEFONO}
                </a>
              </li>
              <li className="flex items-center justify-center gap-2.5">
                <Mail size={15} className="text-amber-400" /> {EMAIL}
              </li>
              <li className="flex items-center justify-center gap-2.5">
                <MapPin size={15} className="text-amber-400" /> {INDIRIZZO}
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center gap-5 border-t border-slate-800 pt-8 text-center">
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2" aria-label="Pagine del sito">
            {LINK_PAGINE.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                data-testid={`footer-pagina-${l.path.slice(1)}`}
                className="text-xs text-slate-500 transition-colors hover:text-amber-400"
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <p className="text-xs text-slate-500">
            © 2026 SOS Riparazioni 24 · P.IVA 01234567890 · Tutti i diritti riservati
          </p>
          <Link
            to="/admin"
            data-testid="footer-area-riservata"
            className="text-xs text-slate-500 transition-colors hover:text-amber-400"
          >
            Area riservata
          </Link>
        </div>
      </div>
    </footer>
  );
}
